import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import DisplayContainer from './containers/DisplayContainer';
import MiamiContainer from './Components/Theme/Miami/MiamiContainer';
import TampaContainer from './Components/Theme/Tampa/TampaContainer';
import OmahaContainer from './Components/Theme/Omaha/OmahaContainer';
import NewarkContainer from './Components/Theme/Newark/NewarkContainer';
import SeattleContainer from './Components/Theme/Seattle/SeattleContainer';
import DenverDonorListsContainer from './Components/Theme/Denver/DenverDonorListsContainer';
import DenverStoriesContainer from './Components/Theme/Denver/DenverStoriesContainer';
import PreviewContainer from './Components/Preview/PreviewContainer';
import AlbuquerqueContainer from './Components/Theme/Albuquerque/AlbuquerqueContainer';
import dc2x1 from './containers/dc2x1';
import dc3x1 from './containers/dc3x1';
import DonorSeaContainer from './containers/DonorSeaContainer';
import DonorContainer from './containers/DonorContainer';
import QuoteContainer from './containers/QuoteContainer';
import DebugContainer from './containers/DebugContainer';
import QuoteShort from './Components/Quote/QuoteShort';
import VerticalVideoSync from './containers/VerticalVideoSync';
import { connect } from 'react-redux';
import _ from 'lodash';
import config from '../config'
import { fetchContent, fetchModuleContent } from './actions/content';
import { fetchDonors } from './actions/donors';
import { fetchDisplay } from './actions/display';
import shared from './utils/shared';
import pkg from '../package.json';

class App extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            contentInit: false,
            displayInit: false,
        }
        this._mode = "local"
        this._module_id = null;
        this._module = null;
        this._project = null;
        this._displayId = 1
        this._baseURL = ""
        this._webkey = null
        this._initialRender = false;
        this._entrySuccessful = false;

        if (this.props.clearLocal==='true'){
            console.log("clearing local storage for window name");
            localStorage.removeItem('entryPoint_'+self.window.name);
        }

    }

    componentDidMount() {
        //window.addEventListener('beforeunload', this.handleWindowClose);

        this._baseURL = window.location.origin;

        console.log("pdg-digital-cms client v" + pkg.version + " running in: " + process.env.NODE_ENV + " ENV");
        window.onerror = (msg, url, lineNo, columnNo, error) => {
            console.log("-----WINDOW ONERROR-----")
            console.log(JSON.stringify({
                msg: msg,
                url: url,
                lineNo: lineNo,
                columnNo: columnNo,
                error: error
            }))
            let refreshPage = false;
            switch(msg){
                case "ResizeObserver loop limit exceeded":
                break;
                default:
                refreshPage = true;

            }
            if (refreshPage === true){
                shared.checkData(null, this.props.content.entry_point || "");
            }

            return false;
        }

        let fetchInterval = 25000 //once per minute
        if (process.env.NODE_ENV === "development") {
            fetchInterval = 25000;
        }

        let modeParam = shared.parseStringParam(window.location.href, "mode");
        let displayId = shared.parseStringParam(window.location.href, "display");
        let webkey = shared.parseStringParam(window.location.href, "webkey");
        let module = shared.parseStringParam(window.location.href, "module");
        let module_id = shared.parseStringParam(window.location.href, "module_id");
        let project = shared.parseStringParam(window.location.href, "project");


        if (displayId) {
            this._displayId = displayId
        } else {
            if (typeof config.DISPLAY !== 'number') {
                this._displayId = config.DISPLAY[0];
            }
        }
        if (webkey) {
            this._webkey = webkey
        }

        if (modeParam === "prvw") {
            this._mode = "preview";
        }
        if (modeParam === "web") {
            this._mode = "web";
        }
        if (modeParam === "module") {
            this._project = project;
            this._module = module;
            this._module_id = module_id;
            this._mode = "module";
        }

        this.firstDisplayContent = setTimeout(() => {
            this.fetchDisplayContent();
        }, 1000);
        this.firstDonorContent = setTimeout(() => {
            this.fetchDonorContent();
        }, 2000);

        if (this._mode !== "preview") { //only fetch once for preview
            this._contentInterval = setInterval(() => {
                this.fetchDisplayContent();
            }, fetchInterval);

            this._donorsInterval = setInterval(() => {
                this.fetchDonorContent();
            }, fetchInterval);

        }
    }

    fetchDisplayContent = () => {
        if (this._mode === "preview") {
            this.props.fetchContent(config.WEB_SERVER + '/display/fetchDisplayContents?mode=prvw&localLastUpdate=0&display=' + this._displayId, 0, this._webkey);
        }
        else if (this._mode === "web") { //live web version
            this.props.fetchContent(config.WEB_SERVER + '/display/fetchDisplayContents?mode=web&localLastUpdate=0&display=' + this._displayId, 0, this._webkey);
        }
        else if (this._mode === "module") {
            this.props.fetchModuleContent(config.WEB_SERVER + '/display/fetchModuleContents?mode=prvw&module=' + this._module + '&project=' + this._project + '&module_id=' + this._module_id, this._webkey);
        }
        else { //form offline file
            if (typeof config.DISPLAY === "number") {
                this.props.fetchContent(this._baseURL + '/data/displayContents.json', 0, this._mode);
            } else {
                this.props.fetchContent(this._baseURL + '/data/display_' + this._displayId + '_contents/displayContents.json', 0, this._mode);
            }
        }
    }

    fetchDonorContent = () => {
        if (this._mode === "preview") {
            this.props.fetchDonors(config.WEB_SERVER + '/display/fetchDonorContents?mode=prvw&localLastUpdate=0&display=' + this._displayId, 0, this._webkey);
        }
        else if (this._mode === "web") { //live web version
            this.props.fetchDonors(config.WEB_SERVER + '/display/fetchDonorContents?mode=web&localLastUpdate=0&display=' + this._displayId, 0, this._webkey);
        }
        else { //form offline file
            this.props.fetchDonors(this._baseURL + '/data/donorContents.json', 0);
        }
    }



    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
        clearInterval(this._contentInterval);
        clearInterval(this._donorsInterval);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.props.content || !this.props.donors) {
            return;
        }
        if (_.isEmpty(this.props.content)) {
            return;
        }
        if (this.state.displayInit === false) {
            let blocks = _.get(this.props, 'content.settings.display_blocks', []);
            this.props.fetchDisplay({ screenHeight: window.innerHeight, screenWidth: window.innerWidth, mode: this._mode, webkey: this._webkey, blocks: blocks, entry_point: this.props.content.entry_point });
            this.setState({
                displayInit: true
            })
        }
        if (this.props.content.last_update !== prevProps.content.last_update) {
            if (this.state.contentInit === true) {
                shared.checkData(null, this.props.content.entry_point || "");
            }
            else {
                this.setState({
                    contentInit: true
                })
            }
        }
        if (this.props.donors.last_update !== prevProps.donors.last_update) {
            if (this.state.donorsInit === true) {
                //console.log("content updated, re-init");
                shared.checkData(null);
            }
            else {
                //console.log("donor init complete");
                this.setState({
                    donorsInit: true
                })
            }
        }
    }

    render() {
        if (this.props.entryforce === true && this._entrySuccessful === false) {
            //first try local storage (better support for multi displays);
            let entry_point = localStorage.getItem('entryPoint_'+self.window.name);
            console.log("getting local storage entry point", entry_point);
            if (!entry_point){
                entry_point = window.location.href;
                //remove clear local from future refreshes
                entry_point = entry_point.replace('&clearLocal=true','');
                console.log("setting local storage entry", entry_point)
                self.window.name=new Date().getTime();
                localStorage.setItem('entryPoint_'+self.window.name, entry_point);
            }
            else{
                this._entrySuccessful = true;
                if (entry_point !== window.location.href && entry_point !== window.location.href.replace('&clearLocal=true','')) {
                    console.log("local storage redirection", entry_point)
                    window.location = entry_point;
                }
            }
        }

        if ((!this.props.content.last_update || !this.props.donors.last_update || !this.props.screen) && (this._mode !== "module")) {
            let errStr = "Waiting on data:";
            if (!this.props.content.last_update) {
                errStr += " Content..."
            }
            if (!this.props.donors.last_update) {
                errStr += " Donor Content..."
            }
            if (!this.props.screen) {
                errStr += " Screen Content..."
            }
            console.log(errStr);

            return (
                <span style={{color: '#777777'}}>Loading...</span>
            )
        }
        if (!this._initialRender) {
            console.log("All app content recieved, proceeding.")
            this._initialRender = true;
        }

        return (
            <div>
                <BrowserRouter>
                    <Switch>
                        <Route path='/VerticalVideoSync' component={VerticalVideoSync} />
                        <Route path='/dc2x1' component={dc2x1} />
                        <Route path='/dc3x1' component={dc3x1} />
                        <Route path='/DonorSeaContainer' component={DonorSeaContainer} />
                        <Route path='/DonorContainer' component={DonorContainer} />
                        <Route path='/QuoteContainer' component={QuoteContainer} />
                        <Route path='/QuoteShort' component={QuoteShort} />
                        <Route path='/Debug' component={DebugContainer} />
                        <Route path='/tampa' component={TampaContainer} />
                        <Route path='/miami' component={MiamiContainer} />
                        <Route path='/omaha' component={OmahaContainer} />
                        <Route path='/seattle' component={SeattleContainer} />
                        <Route path='/newark' component={NewarkContainer} />
                        <Route path='/preview' component={PreviewContainer} />
                        <Route path='/denver' component={DenverDonorListsContainer} />
                        <Route path='/denver-stories' component={DenverStoriesContainer} />
                        <Route path='/albuquerque' component={AlbuquerqueContainer} />
                        <Route path='/' component={DisplayContainer} />
                    </Switch>
                </BrowserRouter>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    let entryforce = shared.parseStringParam(window.location.href, "entryforce") || true;
    let clearLocal = shared.parseStringParam(window.location.href, "clearLocal") || false;

    return {
        content: state.content,
        donors: state.donors,
        screen: state.screen,
        entryforce: entryforce,
        clearLocal: clearLocal
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchContent: (url, contentLastUpdated, webkey) => dispatch(fetchContent(url, contentLastUpdated, webkey)),
        fetchDonors: (url, contentLastUpdated, webkey) => dispatch(fetchDonors(url, contentLastUpdated, webkey)),
        fetchModuleContent: (url, module, module_id, webkey) => dispatch(fetchModuleContent(url, module, module_id, webkey)),
        fetchDisplay: (data) => dispatch(fetchDisplay(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/App.js